import { sendCode, checkCode } from "../../../apis/httpHelper"

export default {
    data:function(){
        return{
            checkInButtonDisable:false,
            checkInButton:"获取验证码",

            lastCheckInTimer:{},
            lastUpdateDateTimer:{},
            endTime : 60,
            successPhone:"",
            successCode:"",

            Error:0,
            checkInState:false
        }
    },
    computed:{
        phoneFinished:function(){
            return this.phone.length == 11;
        },

        computedcheckInButtonDisable:function(){
            if(this.phoneFinished){
                return this.checkInButtonDisable;
            }
            else{
                return true;
            }
        }, 

        computedcheckInInputDisable:function(){
            if(this.phoneFinished){
                return !this.checkInButtonDisable;
            }
            else{
                return true;
            }
        }
    },

    methods:{
        checkInCodeInputChange:function(){
            if(this.checkInCodeInput.length == 6){
                checkCode(this.phone, this.checkInCodeInput)
                    .then(x=>{
                        this.successPhone = this.data[this.name];
                        this.successCode = this.checkInCodeInput;
                        this.checkInState = true;
                    })
                    .catch(x=>{
                        this.checkInState = false;
                    });
            }
        },

        sendVerifierCode:function(){
            if(!this.computedcheckInButtonDisable){
                sendCode(this.phone)
                    .then(x=>{
                        this.callback1();
                    });
            }
        },

        callback1:function(){
            this.checkInButtonDisable = true;
            this.endTime = 60;
            this.checkInButton = "重新获取（60s）";
            this.successPhone = "";
            this.successCode = "";

            clearTimeout(this.lastCheckInTimer);
            this.lastCheckInTimer = setTimeout(()=>{
                clearInterval(this.lastUpdateDateTimer);
                this.checkInButtonDisable = false;
                this.checkInButton = "获取验证码";
            },60000);

            clearInterval(this.lastUpdateDateTimer);
            this.lastUpdateDateTimer = setInterval(()=>{
                this.endTime = this.endTime - 1;
                this.checkInButton = "重新获取（" + this.endTime+ "s）";
            },1000);
        }
    }
}